import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const TopHoldingsChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-secondary">No holdings data available</p>
      </div>
    );
  }

  const chartData = data.map((holding, index) => ({
    name: holding.symbol,
    fullName: holding.name,
    percentage: holding.percentage,
    value: holding.current_value,
    sector: holding.sector,
    rank: index + 1
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="surface-panel p-3">
          <p className="text-primary font-medium">{data.fullName}</p>
          <p className="text-secondary text-sm">{data.symbol} • {data.sector}</p>
          <p className="text-pine font-bold">
            {data.percentage.toFixed(1)}% of portfolio
          </p>
          <p className="text-faint text-sm">
            Value: ${data.value.toLocaleString()}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 60,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="var(--hairline)" />
          <XAxis
            dataKey="name"
            stroke="var(--ink-muted)"
            fontSize={12}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis
            stroke="var(--ink-muted)"
            fontSize={12}
            label={{
              value: 'Percentage (%)',
              angle: -90,
              position: 'insideLeft',
              style: { textAnchor: 'middle', fill: 'var(--ink-muted)' }
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="percentage"
            fill="var(--pine)"
            radius={[4, 4, 0, 0]}
            fillOpacity={1}
          />
        </BarChart>
      </ResponsiveContainer>
      
      <div className="mt-6 overflow-x-auto">
        <table className="import-table w-full">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Symbol</th>
              <th>Name</th>
              <th>Sector</th>
              <th className="text-right">Value</th>
              <th className="text-right">% of Portfolio</th>
            </tr>
          </thead>
          <tbody>
            {chartData.map((holding) => (
              <tr key={holding.name} className="hover:bg-pine-tint/30 transition-colors duration-300">
                <td>
                  <span className="inline-flex items-center justify-center w-6 h-6 bg-pine-tint text-pine text-xs font-bold rounded-full">
                    {holding.rank}
                  </span>
                </td>
                <td className="text-primary font-medium">{holding.name}</td>
                <td className="text-secondary text-sm">{holding.fullName}</td>
                <td className="text-faint text-sm">{holding.sector || 'Unknown'}</td>
                <td className="text-primary text-sm text-right figure">
                  ${holding.value.toLocaleString()}
                </td>
                <td className="text-pine font-bold text-right figure">
                  {holding.percentage.toFixed(1)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopHoldingsChart;
